<template>
  <div class="footer_wrap">
    <footer class="footer">
      <div class="title">买修正产品就上修正健康商城，官方正品买的放心！</div>
      <div class="qrcode_wrap">
        <div class="qrcode_item">
          <div class="qrcode_txt">修正健康集团</div>
          <div class="qrcode_img">
            <img src="../../assets/codeImg/xzjkjt.jpg" alt="" />
          </div>
        </div>
        <div class="qrcode_item">
          <div class="qrcode_txt">健康商城</div>
          <div class="qrcode_img">
            <img src="../../assets/codeImg/xzjksc.png" alt="" />
          </div>
        </div>
        <div class="qrcode_item">
          <div class="qrcode_txt">修正药业集团</div>
          <div class="qrcode_img">
            <img src="../../assets/codeImg/xzyyjtgzh.jpg" alt="" />
          </div>
        </div>
      </div>
    </footer>
    <div class="police">
      <span>Copyright © Xiuzheng All rights reserved.</span>
      <span @click="goUrl1()" class="go">&nbsp;吉ICP备12001358号</span>
      <img class="police_img" src="../../assets/image/police_logo.png" alt="" />
      <span @click="goUrl2()" class="go"
        >吉公网安备 22017302000102号&nbsp;</span
      >
      <span>谨防电信网络诈骗&nbsp;</span>
      <span class="licence" @click="handleLook(1)">药品经营许可证</span>
      <span>&nbsp;</span>
      <span class="licence" @click="handleLook(2)">医疗器械经营许可证</span>
      <span>&nbsp;</span>
      <span class="licence" @click="handleLook(3)"
        >第二类医疗器械经营备案凭证</span
      >
      <span>&nbsp;</span>
      <span class="licence" @click="handleLook(4)">食品销售经营资质</span>
      <span>&nbsp;</span>
      <span class="licence" @click="handleLook(5)"
        >药品、医疗器械互联网信息服务备案</span
      >
      <span>&nbsp;</span>
      <span class="licence" @click="convention">平台（网站）公约</span>
    </div>
    <div class="modal_mask" v-if="openModal" @click="handleClose">
      <img class="close" src="../../assets/image/close.png" alt="" />
      <div class="modal_box">
        <div class="box" v-if="lookFlag == 1">
          <img src="../../assets/image/licence1.jpg" alt="" @click.stop="" />
          <img src="../../assets/image/licence1-1.jpg" alt="" @click.stop="" />
          <img src="../../assets/image/licence1-2.jpg" alt="" @click.stop="" />
        </div>
        <img
          src="../../assets/image/licence2.jpg"
          alt=""
          v-else-if="lookFlag == 2"
          @click.stop=""
        />
        <img
          src="../../assets/image/licence3.jpg"
          alt=""
          v-else-if="lookFlag == 3"
          @click.stop=""
        />
        <img
          src="../../assets/image/licence4.jpg"
          alt=""
          v-else-if="lookFlag == 4"
          @click.stop=""
        />
        <img
          src="../../assets/image/licence5.jpg"
          alt=""
          v-else-if="lookFlag == 5"
          @click.stop=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      lookFlag: 1,
      openModal: false,
    };
  },
  methods: {
    goUrl1() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
    goUrl2() {
      window.open("https://beian.mps.gov.cn/#/query/webSearch");
    },
    handleLook(flag) {
      this.lookFlag = flag;
      this.openModal = true;
      document.body.style.overflow = "hidden";
    },
    convention() {
      this.$router.push({
        name: "convention",
      });
    },
    handleClose() {
      this.openModal = false;
      document.body.style.overflow = ""; //出现滚动条
    },
  },
};
</script>

<style scoped lang="stylus">
.footer_wrap {
  width: 100%;
  background: #F3F3F9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 318px;
  position: relative;

  .footer {
    display: flex;
    justify-content: center;
    align-items: center;

    .title {
      font-size: 28px;
      font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
      font-weight: 800;
      color: #000000;
      line-height: 42px;
      letter-spacing: 1px;
      background: linear-gradient(90deg, #2075EE 0%, #014EA2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      margin-right: 382px;
    }

    .qrcode_wrap {
      display: flex;

      .qrcode_item {
        margin: 0 10px;

        .qrcode_txt {
          font-size: 16px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          color: #014EA2;
          text-align: center;
          margin-bottom: 10px;
        }
      }

      .qrcode_img {
        width: 130px;
        height: 130px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .police {
    position: absolute;
    bottom: 7px;
    display flex;
    align-items center;
    .police_img {
      width: 20px;
      height: 22px;
      margin: 0 6px 0 22px;
    }

    span {
      font-size: 14px;
      font-family: AlibabaPuHuiTiR;
      color: #000000;
    }
    .licence{
      text-decoration:underline;
      cursor: pointer;
      &:hover{
        color: #014EA2;
      }
    }
    .go{
      cursor: pointer;
      &:hover{
        color: #014EA2;
      }
    }
  }

  .modal_mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.4)
    z-index: 999999999;
    .close{
        position: absolute;
        right: 40px;
        top: 30px;
        cursor: pointer;
      }
    .modal_box{
      // position: absolute;
      // left: 50%;
      // top: 50%;
      // transform: translate(-50%,-50%);
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      .box{
        max-width 90%
        max-height: 70%;
        display: flex;

       img{
        max-width: 33%;
        max-height: 100%;
        margin: 0 5px;
        display: block;     /* 避免底部留白（因 img 是 inline 元素） */
      }
      }
      img{
        width: auto;
        max-height: 70%;
        display: block;     /* 避免底部留白（因 img 是 inline 元素） */
      }
    }
  }

}
</style>
